import React, { Component } from 'react';
import Container from 'react-bootstrap/Container'

import "./style.css";
import ComponentLargeForm from './component';

import { reducer } from "./reducer";
import { createStore, applyMiddleware, combineReducers } from "redux";
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from "redux-saga";
import { watchUsers } from "./saga";
import { Provider } from 'react-redux';
import { reducer as formReducer } from 'redux-form';
//import { Auth0Provider } from "@auth0/auth0-react";
import "@fontsource/red-hat-display";
import { AuthProvider } from '../../components/authprovider/auth';

const sagaMiddleware = createSagaMiddleware();
const rootReducer = combineReducers({
    localReducer: reducer,
    form: formReducer,
});

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(sagaMiddleware)));
sagaMiddleware.run(watchUsers);

export default class EmpresasPage extends Component {

    render() {
        return (

            // <Auth0Provider>
            <AuthProvider>
                <Provider store={store}>
                    <Container className='main-wrapper auth' >
                        <ComponentLargeForm params={this.props} />
                    </Container>
                </Provider>
            </AuthProvider>
            // </Auth0Provider>
        );
    }
}
